/* CS10P homepage only. Reuses the installed Google tag; never configures it. */
(() => {
  'use strict';
  if (window.Shopify?.designMode) return;
  const state = window.__arbCs10pPromotion ||= { bound: new WeakSet(), viewed: false, lastClick: -Infinity };
  const target = 'G-V6NHNVVGTX';
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch { return false; }
  };
  const emit = name => {
    if (!allowed() || typeof window.gtag !== 'function') return false;
    try {
      window.gtag('event', name, {
        send_to: target,
        promotion_id: 'home_hero_cs10p',
        promotion_name: 'Homepage CS10P',
        creative_name: 'cs10p_glp1_202610',
        creative_slot: 'homepage_hero_1',
        items: [{ item_id: 'shopify_US_9016586993820_46843591950492', item_name: 'Segmental Smart Scale CS10P', item_brand: 'Arboleaf', quantity: 1 }]
      });
      return true;
    } catch { return false; }
  };
  document.querySelectorAll('[data-arb-promotion="home_hero_cs10p"]').forEach(slide => {
    if (state.bound.has(slide)) return;
    const link = slide.querySelector('a.ash__cta');
    if (!link || !/\/products\/segmental-smart-scale-cs10p\/?$/.test(new URL(link.href).pathname)) return;
    state.bound.add(slide);
    let ratio = 0, timer = 0;
    const active = () => !document.hidden && slide.isConnected && slide.classList.contains('is-active') && slide.getAttribute('aria-hidden') !== 'true' && !slide.inert;
    const exposed = () => {
      if (!active() || ratio < 0.5) return false;
      const r = slide.getBoundingClientRect();
      const left = Math.max(0, r.left), right = Math.min(innerWidth, r.right);
      const top = Math.max(0, r.top), bottom = Math.min(innerHeight, r.bottom);
      if (r.width === 0 || r.height === 0 || (right-left)*(bottom-top) / ((r.width || r.right-r.left)*(r.height || r.bottom-r.top)) < 0.5) return false;
      const points = [[.25,.25],[.75,.25],[.5,.5],[.25,.75],[.75,.75]];
      return points.filter(([x,y]) => slide.contains(document.elementFromPoint(left + (right-left)*x, top + (bottom-top)*y))).length >= 3;
    };
    const cancel = () => { clearTimeout(timer); timer = 0; };
    const reconcile = () => {
      if (state.viewed) { cancel(); observer?.disconnect(); mutations?.disconnect(); return; }
      if (!allowed() || !exposed()) { cancel(); return; }
      if (!timer) timer = setTimeout(() => {
        timer = 0;
        if (exposed() && emit('view_promotion')) {
          state.viewed = true;
          observer.disconnect(); mutations.disconnect();
        }
      }, 1000);
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      ratio = entries[0].intersectionRatio;
      reconcile();
    }, { threshold: [0, 0.5, 1] }) : null;
    const mutations = new MutationObserver(reconcile);
    if (!state.viewed && observer) {
      observer.observe(slide);
      mutations.observe(slide, { attributes: true, attributeFilter: ['aria-hidden', 'class', 'inert'] });
      document.addEventListener('visibilitychange', reconcile);
      document.addEventListener('visitorConsentCollected', reconcile);
      window.addEventListener('load', reconcile, { once: true });
      // Bounded readiness retries only; no scroll handler or continuous polling.
      [500, 1500, 4000].forEach(delay => setTimeout(reconcile, delay));
    }
    const click = event => {
      if (!event.isTrusted || !active() || (event.type === 'click' ? event.button !== 0 : event.button !== 1)) return;
      const now = performance.now();
      if (now - state.lastClick < 1000) return;
      if (emit('select_promotion')) state.lastClick = now;
    };
    link.addEventListener('click', click, { passive: true });
    link.addEventListener('auxclick', click, { passive: true });
    window.addEventListener('pagehide', cancel);
    window.addEventListener('pageshow', reconcile);
  });
})();

